import { Component, Vue } from "vue-property-decorator";
import { resellerOrderCheckoutStore as store } from "../store";
import * as Models from "../models";

@Component
export default class ResellerProductList extends Vue {
    protected bundleStates: Map<string, boolean> = new Map();

    constructor() {
        super();
    }

    protected created() {
         this.vm.bundles.forEach(p => this.bundleStates.set(p.id, false));
    }

    protected toggleVirtualProducts(bundle: Models.Bundle) {
        this.bundleStates.set(bundle.id, !this.showVirtualProducts(bundle));
        this.bundleStates = new Map(this.bundleStates);
    }

    protected showVirtualProducts(bundle: Models.Bundle) {
        return this.bundleStates.get(bundle.id) === true;
    }

    get vm() {
        return store.orderInfo;
    }

    get translations() {
        return store.translations;
    }
}
